export const version = "units/5.0.6";
//# sourceMappingURL=_version.js.map